import React, { Component } from 'react';
import Select from 'react-select';
import { AddRevenue } from '../../Redux/action/revenueAction';
import {
  dataLocation,
  dataUser,
  spocLocationDetailsZoho,
} from '../Helpers/util';
import './form.css';
import axios from 'axios';
import SwInput from '../Common/FormComponent/SwInput';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from 'dayjs';
import AntDTimePicker from '../Common/AntDDateTimePicker/AntDTimePicker';
import { toast } from 'react-toastify';



const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);
const userDataLocal12 = spocLocationDetailsZoho();

class Courier extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj ? UserObj.company_id : null,
      spocid: UserObj ? UserObj.rec_id : null,
      email: UserObj ? UserObj.email : '',
      dynamicFieldError: false,

      paxError: '',
      pax1Error: '',
      pax2Error: '',
      pax3Error: '',
      pax4Error: '',
      pax5Error: '',

      pax6Error: '',
      pax7Error: '',
      packageError: '',
      deliveryError: '',
      dateError: '',

      func: [
        {
          item_name: '',
          item_weight: '',
          item_width: '',
          item_length: '',
          item_height: '',
          declared_value: '',
        },
      ],
      pax: '',
      pax1: '',
      pax2: '',
      pax3: '',
      pax4: '',
      pax5: '',
      pax6: '',
      pax7: '',
      package: '',
      package1: '',
      delivery: '',
      delivery1: '',
      date: '',
      pickup: '',
      files: null,
      attachmentError: '',
      btnStatus: false,
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: ''
    };
  }

  onItem = (e, index) => {
    let tempState = [...this.state.func];
    tempState[index]['item_name'] = e?.target?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };
  onItem1 = (e, index) => {
    let tempState = [...this.state.func];
    tempState[index]['item_weight'] = e?.target?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };
  onItem2 = (e, index) => {
    let tempState = [...this.state.func];
    tempState[index]['item_length'] = e?.target?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };
  onItem3 = (e, index) => {
    let tempState = [...this.state.func];
    tempState[index]['item_width'] = e?.target?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };
  onItem4 = (e, index) => {
    let tempState = [...this.state.func];
    tempState[index]['item_height'] = e?.target?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };
  onItem5 = (e, index) => {
    let tempState = [...this.state.func];
    tempState[index]['declared_value'] = e?.target?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };

  onPurpose = (selectedOption) => {
    if (!selectedOption) {
      this.setState({
        delivery: null,
        delivery1: "",
        deliveryError: "",
      });
      return;
    }

    this.setState({
      delivery: selectedOption,                 // 👈 store object
      delivery1: String(selectedOption.value),
      deliveryError: "",
    });
  };




  onPurpose1 = (selectedOption) => {
    if (!selectedOption) {
      this.setState({
        package: null,
        package1: "",
        packageError: "",
      });
      return;
    }

    this.setState({
      package: selectedOption,            // 👈 store object
      package1: String(selectedOption.value),
      packageError: "",
    });
  };



  onStartTime = e => {
    this.setState({
      pickup: e?.target?.value,
    });
  };
  onDateChange = e => {
    this.setState({
      date: e?.target?.value,
      dateError: '',
    });
  };

  onPaxChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) { // This regex allows only numbers
      this.setState({
        pax: value,
        paxError: '',
      });
    }
  };

  onPaxChange1 = e => {
    const value = e?.target?.value.trim(); // Trim whitespace

    this.setState({
      pax1: value,
      pax1Error: !value ? "Pickup Location Name can't be empty or whitespace only" : '', // Set error state
    });
  };
  onPaxChange2 = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) { // This regex allows only numbers
      this.setState({
        pax2: value,
        pax2Error: '',
      });
    }
  };
  onPaxChange3 = e => {
    const value = e?.target?.value.trim(); // Trim whitespace
    this.setState({
      pax3: value,
      pax3Error: '',
    });
  };
  onPaxChange4 = e => {
    this.setState({
      pax4: e?.target?.value,
      pax4Error: '',
    });
  };
  onPaxChange5 = e => {
    this.setState({
      pax5: e?.target?.value,
      pax5Error: '',
    });
  };
  onPaxChange6 = e => {
    this.setState({
      pax6: e?.target?.value,
      pax6Error: '',
    });
  };

  onPaxChange7 = e => {
    this.setState({
      pax7: e?.target?.value,
      pax7Error: '',
    });
  };

  removeFormFields(i) {
    let formValues = this.state.func;
    formValues.splice(i, 1);
    this.setState({ formValues });
  }

  resetValue = () => {
    this.setState({
      func: [
        {
          item_name: '',
          item_weight: '',
          item_width: '',
          item_length: '',
          item_height: '',
          declared_value: '',
        },
      ],
      paxError: '',
      pax1Error: '',
      pax2Error: '',
      pax3Error: '',
      pax4Error: '',
      pax5Error: '',

      pax6Error: '',
      pax7Error: '',
      packageError: '',
      deliveryError: '',
      dateError: '',

      pax: '',
      pax1: '',
      pax2: '',
      pax3: '',
      pax4: '',
      pax5: '',
      pax6: '',
      pax7: '',
      package: '',
      package1: '',
      delivery: '',
      delivery1: '',
      date: '',
      pickup: '',
      dynamicFieldError: false,
      attachmentError: '',
    });
    this.setState({
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: ''
    })
  };


  handleFile(e) {

    if (e.target.files[0]) {
      this.setState({
        selectedFile: e.target.files[0],
        selectedFileName: e.target.files[0].name,
        imageSrc: window.URL.createObjectURL(e.target.files[0]),
        value: e.target.value,
      });
    }

    // Getting the files from the input
    this.setState({ files: e.target.files });

    if (e.target.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    }
    else if (e.target.files.length <= 2) {
      this.setState({ attachmentError: "" });
    }
  }


  handleSubmit = e => {


    e.preventDefault();
    let files = this.state.files;
    let formData = new FormData();
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i]);
      }
    }
    let dynamicFieldError = false;
    this.state.func.forEach(item => {
      if (!(item.item_name && item.item_weight && item.declared_value)) {
        dynamicFieldError = true;
      }
    });
    if (this.state.pax === '' || this.state.pax < 0) {
      this.setState({
        paxError: "Pickup Location Pincode can't be empty or negative",
      });
    } else if (this.state.pax1 === '') {
      this.setState({ pax1Error: "Pickup Location Name can't be empty" });
    } else if (this.state.pax2 === '' || this.state.pax2 < 0) {
      this.setState({
        pax2Error: "Drop Location Pincode can't be empty or negative",
      });
    } else if (this.state.pax3 === '') {
      this.setState({ pax3Error: "Drop Location Name can't be empty" });
    } else if (this.state.package === '') {
      this.setState({
        packageError: "Package Type can't be empty",
      });
    } else if (dynamicFieldError) {
      this.setState({ dynamicFieldError: dynamicFieldError });
    } else if (this.state.delivery === '' || this.state.delivery < 0) {
      this.setState({
        deliveryError: "Delivery type can't be empty or negative",
      });
    } else if (this.state.date === '') {
      this.setState({ dateError: "Date  can't be empty" });
    } else if (this.state.files != null && this.state.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    }

    else {
      e.currentTarget.disabled = true
      let param = {};
      let common_param = {
        company_id: this.state.company_id,
        spoc_id: this.state.spocid,
        email: this.state.email,
        company_name: UserObj.company_name,
        category: 'courier',
      };
      let body_param = {
        pickup_location_pincode: this.state.pax,
        pickup_location_name: this.state.pax1,

        drop_location_name: this.state.pax3,
        drop_location_pincode: this.state.pax2,

        pickup_contact_person_name: this.state.pax4,
        pickup_contact_person_number: this.state.pax5,
        delivery_contact_person_name: this.state.pax6,
        delivery_contact_person_number: this.state.pax7,
        package_type: this.state.package1,

        item_details: this.state.func,

        delivery_type: this.state.delivery1,

        date_of_pick_up: this.state.date,
        pickup_time: this.state.pickup,
      };
      param.common_param = common_param;
      param.body_param = body_param;
      // AddRevenue(param, this.props.onClose)
      //   .then(() => {
      //     // success handled by onClose
      //     this.setState({ btnStatus: false });
      //     e.currentTarget.disabled = false;
      //   })
      //   .catch(() => {
      //     // error toast already shown in AddRevenue
      //     this.setState({ btnStatus: false });
      //     e.currentTarget.disabled = false;
      //   });
      // e.currentTarget.disabled = false
      AddRevenue(param, (success, message) => {
        if (success) {
          toast.success(message);
          this.resetValue();
          if (this.props.onClose) {
            this.props.onClose();
          }
        }
        this.setState({ btnStatus: false });
        e.currentTarget.disabled = false;
      });
    }
  };
  render() {
    const selectLocationData = [];
    if (this.state.locationSpoc && this.state.locationSpoc.length > 0) {
      this.state.locationSpoc.map(item => {
        if (item.rec_id) {
          selectLocationData.push({
            value: item['location_name_zoho'],
            label: item['location_name_zoho'],
          });
        }
        // selectLocationIds.push(JSON.stringify(item['rec_id']))
      });
    }
    const options1 = [
      { value: 'Document', label: 'Document' },
      { value: 'Non Document', label: 'Non Document' },
    ];

    const options3 = [
      { value: 'Premium', label: 'Premium' },
      { value: 'Standard', label: 'Standard' },
    ];

    return (
      <>


        <div className="row">
          <div className="col-6 pr-2">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Pickup Location Pincode <span className="Required">*</span></label>
              <SwInput
                value={this.state.pax}
                id="courier-location-pincode-input"
                onChange={this.onPaxChange}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              <span className="SwTextDanger SwTextSmall">
                {this.state.paxError}
              </span>
            </div>
          </div>

          <div className="col-6 pl-2">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Pickup Location Name <span className="Required">*</span></label>
              <SwInput
                value={this.state.pax1}
                id="courier-location--name-input"
                onChange={this.onPaxChange1}
              />
              <span className="SwTextDanger SwTextSmall">
                {this.state.pax1Error}
              </span>
            </div>
          </div>
        </div>


        <div className="row">
          <div className="col-6 pr-2">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Drop Location Pincode <span className="Required">*</span></label>
              <SwInput
                value={this.state.pax2}
                id="courier-drop-location-pincode-input"
                onChange={this.onPaxChange2}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              <span className="SwTextDanger SwTextSmall">
                {this.state.pax2Error}
              </span>
            </div>
          </div>

          <div className="col-6 pl-2">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Drop Location Name <span className="Required">*</span></label>
              <SwInput
                value={this.state.pax3}
                id="courier-drop-location-name-input"
                onChange={this.onPaxChange3}
              />
              <span className="SwTextDanger SwTextSmall">
                {this.state.pax3Error}
              </span>
            </div>
          </div>
        </div>


        <div className="row">
          <div className="col-6 pr-2">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Pickup Contact Person Name </label>
              <SwInput
                value={this.state.pax4}
                onChange={this.onPaxChange4}
                id="courier-contact-person-name-input"
              />
            </div>
          </div>

          <div className="col-6 pl-2">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Pickup Contact Person Phone</label>
              <SwInput
                type="number"
                onKeyPress={(e) => { if (e.target.value.length > 12) e.preventDefault() }}
                value={this.state.pax5}
                onChange={this.onPaxChange5}
                id="courier-contact-person-phone-input"
              />
            </div>
          </div>
        </div>


        <div className="row">
          <div className="col-6 pr-2">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Delivery Contact Person Name </label>
              <SwInput
                value={this.state.pax6}
                onChange={this.onPaxChange6}
                id="courier-delivery-person-name-input"
              />
            </div>
          </div>
          <div className="col-6 pl-2">
            <div className="SwFormGroup">
              <label className="SwFormLabel"> Delivery Contact Person Phone </label>
              <SwInput
                type="number"
                onKeyPress={(e) => { if (e.target.value.length > 12) e.preventDefault() }}
                value={this.state.pax7}
                onChange={this.onPaxChange7}
                id="courier-delivery-person-phone-input"
              />
            </div>
          </div>
        </div>


        <div className="event1 row">
          <div className="col-md-12">
            <div className="SwFormGroup">
              <label className="SwFormLabel">Choose Package Type <span className="Required">*</span></label>{' '}
              <SwSelect
                placeholder="Select"
                options={options1}
                value={this.state.package}
                onChange={this.onPurpose1}
                id="courier-package-type-select"
              />{' '}
              <span className="SwTextDanger SwTextSmall">
                {this.state.packageError}
              </span>
            </div>
          </div>{' '}
        </div>{' '}


        {this.state.func.map((it, index) => {
          return (
            <div className="event ">
              {' '}
              <div className="event row">
                {' '}
                <div className="col-6 col-md-6 mt-2 pr-2">
                  <div className="SwFormGroup">
                    {' '}
                    <label className="SwFormLabel">Item Name <span className="Required">*</span></label>{' '}
                    <SwInput
                      value={it.item_name}
                      id="courier-item-name-select"
                      onChange={e => {
                        this.onItem(e, index);
                      }}
                    />{' '}
                    {this.state.dynamicFieldError &&
                      !it.item_name && (
                        <span className="SwTextDanger SwTextSmall">
                          {"Item can't be Empty"}
                        </span>
                      )}
                  </div>
                </div>{' '}
                <div className="col-6 col-md-6 mt-2 pl-2">
                  <div className="SwFormGroup">
                    {' '}
                    <label className="SwFormLabel">Weight (KGs) <span className="Required">*</span></label>{' '}
                    <SwInput
                      type="number"
                      id="courier-weight-input"
                      min="0"
                      value={it.item_weight}
                      onChange={e => {
                        this.onItem1(e, index);
                      }}
                    />{' '}
                    {(it.item_weight < 0 ||
                      (this.state.dynamicFieldError &&
                        !it.item_weight)) && (
                        <span className="SwTextDanger SwTextSmall">
                          {"Weight can't be Empty or negative"}
                        </span>
                      )}
                  </div>
                </div>{' '}
                <div className="col-6 col-md-6 mt-2 pr-2">
                  <div className="SwFormGroup">
                    {' '}
                    <label className="SwFormLabel">Length (CMs)</label>{' '}
                    <SwInput
                      value={it.item_length}
                      id="courier-length-input"
                      onChange={e => {
                        this.onItem2(e, index);
                      }}
                    />{' '}
                  </div>
                </div>{' '}
                <div className="col-6 col-md-6 mt-2 pl-2">
                  <div className="SwFormGroup">
                    {' '}
                    <label className="SwFormLabel">Width (CMs)</label>{' '}
                    <SwInput
                      type="number"
                      id="courier-width-input"
                      min="0"
                      value={it.item_width}
                      onChange={e => {
                        this.onItem3(e, index);
                      }}
                    />{' '}
                  </div>
                </div>{' '}
                <div className="col-6 col-md-6 mt-2 pr-2">
                  <div className="SwFormGroup">
                    {' '}
                    <label className="SwFormLabel">Height (CMs)</label>{' '}
                    <SwInput
                      value={it.item_height}
                      id="courier-height-input"
                      onChange={e => {
                        this.onItem4(e, index);
                      }}
                    />{' '}
                  </div>
                </div>{' '}
                <div className="col-6 col-md-6 mt-2 pl-2">
                  <div className="SwFormGroup">
                    {' '}
                    <label className="SwFormLabel">Declared Value (Rs) <span className="Required">*</span></label>{' '}
                    <SwInput
                      type="number"
                      id="courier-declared-value-input"
                      min="0"
                      value={it.declared_value}
                      onChange={e => {
                        this.onItem5(e, index);
                      }}
                    />{' '}
                    {(it.declared_value < 0 ||
                      (this.state.dynamicFieldError &&
                        !it.declared_value)) && (
                        <span className="SwTextDanger SwTextSmall">
                          {
                            "Declared  value can't be Empty or negative"
                          }
                        </span>
                      )}
                  </div>
                </div>{' '}
              </div>{' '}
              {index == 0 ? (
                <div className="col-3 budget-btn mt-4 pl-2 pr-0">
                  {' '}
                  <button
                    type="button"
                    className="pl-0 common addMoreIcon flex mt-3"
                    onClick={() => {
                      let tempState = [...this.state.func];
                      tempState.push({
                        item_name: '',
                        item_weight: '',
                        item_width: '',
                        item_length: '',
                        item_height: '',
                        declared_value: '',
                      });
                      this.setState({
                        func: tempState,
                      });
                    }}
                  >
                    {' '}
                    <i
                      className="fa fa-plus-circle"
                      aria-hidden="true"
                    />{' '}
                    Add more
                  </button>{' '}
                </div>
              ) : (
                <div className="col-md-3 budget-btn removeBtn1 mt-0">
                  {' '}
                  <button
                    type="button"
                    className="common removeBtn1 pt-2"
                    onClick={() => this.removeFormFields(index)}
                  >
                    {' '}
                    <i
                      className="fa fa-trash"
                      aria-hidden="true"
                    />{' '}
                  </button>{' '}
                </div>
              )}
            </div>
          );
        })}


        <div className="event1 row">
          {' '}
          <div className="col-md-12 mt-2">
            <div className="SwFormGroup">
              {' '}
              <label className="SwFormLabel">Delivery type <span className="Required">*</span></label>{' '}
              <SwSelect
                placeholder="Select"
                options={options3}
                id="courier-delivery-type-select"
                value={this.state.delivery}
                onChange={this.onPurpose}
              />{' '}
              <span className="SwTextDanger SwTextSmall">
                {this.state.deliveryError}
              </span>
            </div>
          </div>{' '}
        </div>


        <div className="row">
          <div className="col-md-6">
            <div className="SwFormGroup">
              <label className="SwFormLabel"> Date of Pickup <span className="Required">*</span></label>
              <AntDDatePicker
                value={this.state.date ? dayjs(this.state.date, 'YYYY-MM-DD') : null}
                format="DD/MM/YYYY"
                disabledDate={(current) =>
                  current && current.isBefore(dayjs().startOf('day'))
                }
                onChange={(date) => {
                  this.setState({
                    date: date ? date.format('YYYY-MM-DD') : '',
                    dateError: '',
                  });
                }}
                allowClear={false}
              />

              <span className="SwTextDanger SwTextSmall">
                {this.state.dateError}
              </span>
            </div>
          </div>
          <div className="col-md-6">
            {' '}
            <div className="SwFormGroup">
              <label className="SwFormLabel">Pickup time</label>{' '}
              <AntDTimePicker
                value={this.state.pickup ? dayjs(this.state.pickup, 'HH:mm') : null}
                format="HH:mm"
                placeholder="Select time"
                allowClear={true}
                disabledTime={() => {
                  // If no date selected → allow all
                  if (!this.state.date) return {};

                  const selectedDate = dayjs(this.state.date, 'YYYY-MM-DD');
                  const now = dayjs();

                  // If selected date is NOT today → allow all
                  if (!selectedDate.isSame(now, 'day')) {
                    return {};
                  }

                  const currentHour = now.hour();
                  const currentMinute = now.minute();

                  return {
                    disabledHours: () =>
                      Array.from({ length: currentHour }, (_, i) => i),

                    disabledMinutes: (selectedHour) =>
                      selectedHour === currentHour
                        ? Array.from({ length: currentMinute }, (_, i) => i)
                        : [],
                  };
                }}
                onChange={(time) => {
                  this.setState({
                    pickup: time ? time.format('HH:mm') : '',
                  });
                }}
              />


            </div>
          </div>

        </div>{' '}





      </>
    );
  }
}

export default Courier;
